import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "quiz-score-container"
};
const _hoisted_2 = {
  class: "quiz-completed-title"
};
const _hoisted_3 = {
  key: 0,
  class: "quiz-completed-rate-container-scorm"
};
const _hoisted_4 = {
  class: "rate-section"
};
const _hoisted_5 = {
  class: "percentage"
};
const _hoisted_6 = {
  class: "label"
};
const _hoisted_7 = {
  key: 1,
  class: "quiz-completed-rate-container"
};
const _hoisted_8 = {
  class: "success-rate-card"
};
const _hoisted_9 = {
  class: "rate-section"
};
const _hoisted_10 = {
  class: "percentage"
};
const _hoisted_11 = {
  class: "label"
};
const _hoisted_12 = {
  class: "divider-section"
};
const _hoisted_13 = {
  class: "icon-container"
};
const _hoisted_14 = {
  class: "rate-section"
};
const _hoisted_15 = {
  class: "percentage"
};
const _hoisted_16 = {
  class: "label"
};
const _hoisted_17 = {
  key: 1,
  class: "remaining-tries"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_quiz_readonly_alert = _resolveComponent("quiz-readonly-alert");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_icon, {
    icon: "certificate-outline",
    class: "quiz-completed-icon"
  }), _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('view.speach.examQuiz.score.title')), 1), _ctx.isScorm ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.successRate) + "%", 1), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('view.speach.examQuiz.score.successRateLabel')), 1)])])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.successRate) + "%", 1), _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('view.speach.examQuiz.score.successRateLabel')), 1)]), _createElementVNode("div", _hoisted_12, [_cache[0] || (_cache[0] = _createElementVNode("div", {
    class: "divider-line"
  }, null, -1)), _createElementVNode("div", _hoisted_13, [_createVNode(_component_icon, {
    icon: _ctx.iconClass,
    class: _normalizeClass(['rate-icon', _ctx.iconColorClass])
  }, null, 8, ["icon", "class"])]), _cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "divider-line"
  }, null, -1))]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.scoreToContinue) + "%", 1), _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('view.speach.examQuiz.score.minToContinueLabel')), 1)])]), _ctx.canEdit ? (_openBlock(), _createBlock(_component_quiz_readonly_alert, {
    key: 0,
    "is-speach-template": _ctx.isSpeachTemplate
  }, null, 8, ["is-speach-template"])) : _createCommentVNode("", true), _ctx.remainingTries !== -1 ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t('view.speach.examQuiz.score.nbRemainingTriesLabel', {
    nbRemainingTries: _ctx.remainingTries
  })), 1)) : _createCommentVNode("", true)]))]);
}